"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUpValidationService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const common_2 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("../entities/look-up.entity");
let LookUpValidationService = class LookUpValidationService {
    constructor(dataSource) {
        this.dataSource = dataSource;
    }
    async getIdsForLookupValueKeys(lookupValueKeys) {
        const lookUpRepository = this.dataSource.getRepository(look_up_entity_1.LookUp);
        const lookups = await lookUpRepository.find({
            where: {
                lookUpValueKey: (0, typeorm_1.In)(lookupValueKeys),
            }
        });
        return lookups;
    }
    async validateDynamicLookupValues(payload, lookupData) {
        try {
            const extractIdsToValidate = (obj, lookupData, parentField = "") => {
                const ids = [];
                for (const [field, value] of Object.entries(obj)) {
                    if (Array.isArray(value)) {
                        // Handle arrays by iterating through each element
                        value.forEach((item, index) => {
                            ids.push(...extractIdsToValidate(item, lookupData, `${parentField}${field}[${index}].`));
                        });
                    }
                    else if (typeof value === "object" && value !== null) {
                        // Recursively handle nested objects
                        ids.push(...extractIdsToValidate(value, lookupData, `${parentField}${field}.`));
                    }
                    else if (lookupData[field] !== undefined && value !== null) {
                        // Add the field if it matches the lookupData
                        ids.push({
                            id: value,
                            key: lookupData[field],
                            field: `${parentField}${field}`,
                        });
                    }
                }
                return ids;
            };
            const idsToValidate = extractIdsToValidate(payload, lookupData);
            const lookupKeys = idsToValidate.flatMap(({ key }) => Array.isArray(key) ? key : [key]);
            // Fetch all lookup values for the provided keys
            const lookUpRepository = this.dataSource.getRepository(look_up_entity_1.LookUp);
            const lookups = await lookUpRepository.find({
                where: {
                    lookUpName: (0, typeorm_1.In)(lookupKeys),
                },
            });
            // Validate each ID against the lookup data
            for (const { id, key, field } of idsToValidate) {
                if (!id) {
                    throw new common_1.BadRequestException(`The field corresponding to ${key} is required.`);
                }
                const validKeys = Array.isArray(key) ? key : [key];
                const matchingLookup = lookups.find((lookup) => validKeys.includes(lookup.lookUpName) && lookup.id === id);
                if (!matchingLookup) {
                    throw new common_1.BadRequestException(`The id ${id} does not match a valid lookup value for ${field}.`);
                }
            }
        }
        catch (error) {
            // If the error is a BadRequestException, rethrow it with the same message
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.message);
            }
            // For other errors, throw a generic error
            throw new common_1.BadRequestException("An unexpected error occurred during lookup validation.");
        }
    }
};
exports.LookUpValidationService = LookUpValidationService;
exports.LookUpValidationService = LookUpValidationService = tslib_1.__decorate([
    (0, common_2.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object])
], LookUpValidationService);
